// extracted by mini-css-extract-plugin
export default {"menuMobile":"MenuMobile_menuMobile__5Onil"};